/**
 *
 */
export class VectorHelper {

    /**
     * Maps any object to an array object
     *
     * @param obj        The vector of any type
     * @return            An array with the same items in the same order
     */
    public static toArray(obj: any): any[] {
        if (!obj) {
            return [];
        }

        else if (obj instanceof Array) {
            let array: any[] = new Array(obj.length);

            for (let i: number = 0; i < obj.length; i++) {
                array[i] = obj[i];
            }
            return array;
        }

        else if (obj instanceof Array) {
            return (Array.from(obj));
        }

        else {
            return [];
        }
    }
}
